import { Incident } from './../models/Incident';
import { Component, OnInit } from '@angular/core';
import { MainComponent } from '../main/main.component';
import { GenericTableComponent } from '../generic-components/generic-table/generic-table.component';
import { GenericSearchLabelComponent } from '../generic-components/generic-search-label/generic-search-label.component';
import { Affranchi } from '../models/Affranchi';
import { TableConfig } from '../generic-components/generic-table/class/TableConfig';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericSearchService } from '../generic-components/generic-search/generic-search.service';
import { PageInformations } from '../generic-components/generic-table/class/PageInformations';
import { PageEvent } from '@angular/material/paginator';
import { IncidentService } from '../incident/incident.service';
import { GenericToastrService } from '../generic-components/generic-toastr/generic-toastr.service';
import { DialogRef } from '@angular/cdk/dialog';
import { GenericValidateComponent } from '../generic-components/generic-validate/generic-validate.component';
import { AffranchiDetailsComponent } from './affranchi-details/affranchi-details.component';

@Component({
  selector: 'app-affranchi',
  standalone: true,
  imports: [MainComponent, GenericTableComponent, GenericSearchLabelComponent],
  templateUrl: './affranchi.component.html',
  styleUrl: './affranchi.component.css',
})
export class AffranchiComponent implements OnInit {
  listAffranchis: Affranchi[] = [];

  pageInformations: PageInformations = new PageInformations();

  emitClickRow = 'details';

  tableConfig: TableConfig = {
    columns: [
      {
        id: 'idIncident',
        libelle: 'ID',
        property: 'idAffranchi',
        researchable: false,
      },
      {
        id: 'creationDate',
        libelle: 'Date de création',
        property: 'creationDate',
        type: 'date',
        researchable: false,
      },
      {
        id: 'client',
        libelle: 'Client',
        property: 'client',
        searchOn: 'incidentAffranchi.comparison.correspondance.libelleDivalto',
        researchable: true,
      },
      {
        id: 'type',
        libelle: "Type d'incident affranchi",
        property: 'type',
        searchOn: 'incidentAffranchi.typeIncident.libelle',
        researchable: false,
      },
      {
        id: 'options',
        libelle: 'Options',
        property: 'options',
        researchable: false,
      },
    ],
  };

  constructor(
    private searchService: GenericSearchService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private incidentService: IncidentService,
    private toastr: GenericToastrService
  ) {}

  ngOnInit(): void {
    this.loadAffranchis();
  }

  loadAffranchis(query?: string): void {
    this.spinner.show();

    if (query == null) {
      query = 'idAffranchi>0';
    }
    this.searchService
      .search(
        'incident/affranchi',
        query,
        this.pageInformations.pageIndex,
        this.pageInformations.size,
        'idAffranchi=asc'
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.listAffranchis = res.content;
          this.pageInformations = this.searchService.updatePageInformations(
            this.pageInformations,
            res
          );
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  pageEvent(event: PageEvent) {
    this.pageInformations.pageIndex = event.pageIndex;
    this.pageInformations.pageSize = event.pageSize;
    this.loadAffranchis();
  }

  deleteIncidentAffranchi(affranchi: Affranchi) {
    const dialogRef = this.dialog.open(GenericValidateComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        libelle: 'Voulez-vous vraiment supprimer cet incident affranchi ?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (affranchi.idAffranchi && result === true) {
        this.incidentService.deleteAffranchi(affranchi.idAffranchi).subscribe(
          (result) => {
            this.toastr.openSnackBarSuccess(
              'Incident affranchi supprimé avec succés !'
            );
            this.loadAffranchis();
          },
          (error) => {
            this.toastr.openSnackBarProblem(error.error.message);
          }
        );
      }
    });
  }

  openDetails(row: any){
    this.dialog.open(AffranchiDetailsComponent, {
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        affranchi: row
      }
    })
  }
}
